// src/components/home/HomeHeroSlider.js
import React from 'react';
import { Link } from 'react-router-dom';

// Swiper core
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation, A11y, EffectFade } from 'swiper/modules';

// Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';

import './HomeHeroSlider.css';

 import pb from '../../lib/pocketbase';

const slides = [
  {
    id: 's1',
    image: '/images/blog/b1.png',
    title: 'Sites Web qui Convertissent',
    text: "Design premium, SEO efficace et performances au top pour booster votre activité.",
    cta: { label: 'Parler de votre projet', href: '/contact' },
  },
  {
    id: 's2',
    image: '/images/blog/b5.png',
    title: 'E-commerce, Vitrine, Apps',
    text: "Nous concevons et développons des expériences sur-mesure, prêtes à scaler.",
    cta: { label: 'Découvrir nos services', href: '/services' },
  },
  {
    id: 's3',
    image: '/images/blog/b7.png',
    title: 'Accompagnement de A à Z',
    text: "De l’idée au déploiement, nous restons à vos côtés pour assurer vos résultats.",
    cta: { label: 'Nos réalisations', href: '/realisations' },
  },
];

function pbFileUrl(record, fileField, thumb) {
  try {
    if (!record || !record[fileField]) return '';
    return pb.files.getUrl(record, record[fileField], thumb ? { thumb } : undefined);
  } catch {
    return '';
  }
}

function sameOriginInternalPath(href) {
  try {
    if (!href) return '';
    if (typeof window === 'undefined' || !window.location?.origin) return '';
    const u = new URL(href, window.location.origin);
    if (u.origin !== window.location.origin) return '';
    return `${u.pathname}${u.search}${u.hash}`;
  } catch {
    return '';
  }
}

function HomeHeroSlider() {
  const [remoteSlides, setRemoteSlides] = React.useState([]);

  React.useEffect(() => {
    let mounted = true;
    const fetchSlides = async () => {
      try {
        const res = await pb.collection('site_home_slides').getList(1, 50, {
          sort: 'sort_order, -created',
          filter: 'is_active = true',
        });
        const items = (res?.items ?? []).map((it) => {
          const img = pbFileUrl(it, 'image', '2000x0') || '';
          const href = it?.cta_url || '';
          const label = it?.cta_label || '';
          const openNew = !!it?.open_in_new_tab;
          return {
            id: it.id,
            image: img,
            title: it?.title || '',
            text: it?.subtitle || '',
            cta: href ? { label: label || 'En savoir plus', href, openNew } : null,
          };
        }).filter(s => !!s.image || !!s.title || !!s.text);

        if (mounted) setRemoteSlides(items);
      } catch {
        if (mounted) setRemoteSlides([]);
      }
    };
    fetchSlides();
    return () => { mounted = false; };
  }, []);

  const data = remoteSlides.length ? remoteSlides : slides;

  return (
    <section className="home-hero-slider" aria-label="Mises en avant INFO COLAB">
      <Swiper
        modules={[Autoplay, Pagination, Navigation, A11y, EffectFade]}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        loop={true}
        speed={800}
        autoplay={{ delay: 4500, disableOnInteraction: false, pauseOnMouseEnter: true }}
        pagination={{ clickable: true }}
        navigation
        className="home-hero-swiper"
      >
        {data.map((s) => (
          <SwiperSlide key={s.id}>
            <div className="hero-slide" style={{ backgroundImage: `url(${s.image})` }}>
              <div className="hero-slide-overlay">
                <div className="hero-slide-content">
                  <h2 className="hero-slide-title">{s.title}</h2>
                  <p className="hero-slide-text">{s.text}</p>
                  <div className="hero-slide-actions">
                    {s.cta?.href ? (
                      (() => {
                        const internal = sameOriginInternalPath(s.cta.href);
                        if (internal && !s.cta.openNew) {
                          return (
                            <Link to={internal} className="btn btn-primary">
                              {s.cta.label}
                            </Link>
                          );
                        }
                        if (internal && s.cta.openNew) {
                          return (
                            <a href={internal} target="_blank" rel="noreferrer" className="btn btn-primary">
                              {s.cta.label}
                            </a>
                          );
                        }
                        if (s.cta.href.startsWith('http')) {
                          return (
                            <a href={s.cta.href} target={s.cta.openNew ? '_blank' : undefined} rel={s.cta.openNew ? 'noreferrer' : undefined} className="btn btn-primary">
                              {s.cta.label}
                            </a>
                          );
                        }
                        return (
                          <Link to={s.cta.href} className="btn btn-primary">
                            {s.cta.label}
                          </Link>
                        );
                      })()
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default HomeHeroSlider;
